import React from 'react'

import {
    CircularProgress,
    IconButton,
    Modal,
    Paper,
    Slide,
    useTheme,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import { Container } from '../Container'
import {
    ActionItemAnalytic,
    ActionItemDetailAnalytics,
    AnalyticsLoadingState,
} from '../../hooks/useEZFolioWorkorderAnalytics'
import { toMMDDYYYY } from '../../helpers'
import ActionItemCharts from './ActionItemCharts'
import { typographyStyle } from '../../theme/typographyStyle'

interface Props {
    open: boolean
    actionItemDetailAnalytics: ActionItemDetailAnalytics | null
    activeActionItemAnalytic: ActionItemAnalytic | null
    startDate: string
    endDate: string
    loadingState: AnalyticsLoadingState
    handleClose: () => void
}

export const ActionItemAnalyticModal = (props: Props) => {
    const {
        open,
        actionItemDetailAnalytics,
        activeActionItemAnalytic,
        startDate,
        endDate,
        loadingState,
        handleClose,
    } = props

    const theme = useTheme()

    const startDateString = toMMDDYYYY(new Date(startDate))
    const endDateString = toMMDDYYYY(new Date(endDate))

    return (
        <Modal
            open={open}
            onClose={handleClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
            }}
        >
            <Slide direction="up" in={open}>
                <Paper
                    style={{
                        width: 'calc(100vw - 250px)',
                        backgroundColor: theme.palette.background.paper,
                        height: 'calc(100vh - 150px)',
                    }}
                >
                    <Container
                        style={{
                            flex: 1,
                            flexDirection: 'column',
                            height: '100%',
                        }}
                    >
                        <Container
                            style={{
                                padding: theme.spacing(1, 2),
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderBottom: `1px solid ${theme.palette.grey[400]}`,
                            }}
                        >
                            <span
                                style={{
                                    ...typographyStyle(theme.typography.h6),
                                    fontWeight: 700,
                                    flex: 1,
                                }}
                            >
                                {activeActionItemAnalytic?.apartment_name}{' '}
                                Action Items Details
                                <span style={{ marginLeft: theme.spacing(1) }}>
                                    {startDateString} - {endDateString}
                                </span>
                            </span>
                            <IconButton onClick={handleClose} size="small">
                                <Close />
                            </IconButton>
                        </Container>

                        {loadingState.detailPage ? (
                            <Container
                                style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <CircularProgress size={50} />
                            </Container>
                        ) : (
                            actionItemDetailAnalytics && (
                                <ActionItemCharts
                                    analytics={actionItemDetailAnalytics}
                                    loadingState={loadingState}
                                />
                            )
                        )}
                    </Container>
                </Paper>
            </Slide>
        </Modal>
    )
}
